import { baseApi } from '@app/store/index.api';
import { DownloadResponse } from '@shared/types/download';

import {
  IOrderBulkResendCallbackQuery,
  IOrderBulkResendCallbackResponse,
  IOrderApproveQuery,
  IOrderApproveARSQuery,
  IOrderApproveKRWQuery,
  IOrderApproveResponse,
  IOrderExportQuery,
} from '../model/types';

const ordersApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    approveOrder: builder.mutation<IOrderApproveResponse, IOrderApproveQuery>({
      query: ({ id, actual_amount, customer_transaction_id, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually`,
          method: 'POST',
          body: { actual_amount, customer_transaction_id, reason },
        };
      },
    }),
    approveOrderARS: builder.mutation<IOrderApproveResponse, IOrderApproveARSQuery>({
      query: ({ id, actual_amount, cuit_cuil, coelsa_id, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually-ars`,
          method: 'POST',
          body: { actual_amount, cuit_cuil, coelsa_id, reason },
        };
      },
    }),
    approveOrderKRW: builder.mutation<IOrderApproveResponse, IOrderApproveKRWQuery>({
      query: ({ id, actual_amount, account_name, account_number, bank_name, reason }) => {
        return {
          url: `/orders/deposits/${id}/approve-manually-sk`,
          method: 'POST',
          body: { actual_amount, account_name, account_number, bank_name, reason },
        };
      },
    }),
    bulkResendCallbackOrder: builder.mutation<
      IOrderBulkResendCallbackResponse,
      IOrderBulkResendCallbackQuery
    >({
      query: ({ ids }) => {
        return {
          url: `/orders/statuses/send-bulk`,
          method: 'POST',
          body: { ids },
        };
      },
    }),
    ordersExportsDownload: builder.mutation<
      DownloadResponse,
      IOrderExportQuery & { type: 'deposits' | 'withdrawals' }
    >({
      query: ({ type, ...query }) => {
        return {
          url: `/orders/${type}/exports/download`,
          method: 'POST',
          body: query,
          responseHandler: async response => {
            return await response.json();
          },
        };
      },
    }),
  }),
});

export const {
  useBulkResendCallbackOrderMutation,
  useApproveOrderMutation,
  useApproveOrderARSMutation,
  useApproveOrderKRWMutation,
  useOrdersExportsDownloadMutation,
} = ordersApi;
